import * as React from 'react'

const MHNameText = (props) => {
  return (
    <span className="-label">
        { props.name }
  </span>
  )
}

export default MHNameText